module.exports = __webpack_public_path__ + "media/images/riders/small/ANNE_TAUBER-5785601f709e62815486a16c01ce69a0.png";